module.exports = __webpack_public_path__ + "img/ISBT.b3950f46.png";